import { render, staticRenderFns } from "./course-video-list.vue?vue&type=template&id=799179de&scoped=true&"
import script from "./course-video-list.vue?vue&type=script&lang=js&"
export * from "./course-video-list.vue?vue&type=script&lang=js&"
import style0 from "./course-video-list.vue?vue&type=style&index=0&id=799179de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799179de",
  null
  
)

export default component.exports